<ng-template libCustomHost></ng-template>
